export default {
    mapInformationDigestToContentReply(digestDetail) {
        return {
            createdDate: digestDetail.CreatedDateTimeOffset,
            creator: {
                name:digestDetail.Creator.DisplayName,
                displayImage: digestDetail.Creator.ProfileImage,
                gender: digestDetail.Creator.AdditionalProperties.Gender
            },
            displayText: digestDetail.AdditionalProperties.ContentItemPropertyValue,
            displayJson: digestDetail.AdditionalProperties.ContentItemPropertyMeta
        }
    }
}
